import { RslReport } from '@features/campaigns/subdomains/rsl';
import { Slide } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from '../../../slides/slide-master';
import { shapes } from './sales-optimization-summary/shapes';
import { images } from './sales-optimization-summary/images';
import { texts } from './sales-optimization-summary/texts';

export type SalesOptimizationSummaryOptions = {
  midCampaignReport: RslReport | null;
  currentReport: RslReport;
};

export const salesOptimizationSummarySlide = (
  options: SalesOptimizationSummaryOptions
): Slide => {
  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts: texts(options),
    shapes,
    images: images(options),
  };
};
